/**
 * Resolves a selected version value into the path prefix used to locate
 * files in the Config Git Repository.
 *
 * - "current" maps to "current/" (work-in-progress directory)
 * - Any other value maps to "releases/{value}/" (versioned snapshot)
 *
 * The returned path is used as the Version_Path segment in the full source path:
 *   {Version_Path}/{Configuration_Sub_Path}/{Source_Root}/{Source_Location}/{Source_Filename}
 */
export function resolveVersionPath(version: string): string {
  if (version === 'current') {
    return 'current/';
  }
  return `releases/${version}/`;
}
